/**
 * Two remaining fixes, September 2026. Kept separate from a11y-site.js only
 * so each file stays short and readable.
 *
 *  1. The video poster image the theme renders with `hidden` has no alt
 *     attribute and sits inside a link, so a screen reader can announce its
 *     filename. It is hidden and purely decorative, so an empty alt is the
 *     correct answer -- it tells assistive tech to skip it. These posters are
 *     inserted lazily as the shopper scrolls, so we watch for them.
 *
 *  2. The testimonial carousel scrolls horizontally but could not be given
 *     keyboard focus, so a keyboard user could not scroll it with the arrow
 *     keys (WCAG 2.1.1). Making the scroll container focusable fixes that.
 *     It already has arrow buttons; this adds the scrolling itself.
 */
(function () {
  'use strict';

  function fixHiddenPosterImages() {
    var imgs = document.querySelectorAll('img[hidden]:not([alt]), img:not([alt])');
    Array.prototype.forEach.call(imgs, function (img) {
      // An image inside a link normally needs real alt text, because it is the
      // link's only name -- unless it is hidden, in which case it is decorative.
      if (!img.hasAttribute('hidden') && (img.closest('a') || img.closest('button'))) return;
      img.setAttribute('alt', '');
    });
  }

  function makeScrollableRegionsFocusable() {
    var regions = document.querySelectorAll('.slideshow, .carousel-slider, [class*="__inner"]');
    Array.prototype.forEach.call(regions, function (el) {
      if (el.hasAttribute('tabindex')) return;
      if (el.scrollWidth <= el.clientWidth + 2 && el.scrollHeight <= el.clientHeight + 2) return;
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('role')) el.setAttribute('role', 'group');
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Scrollable content');
    });
  }

  function run() {
    try { fixHiddenPosterImages(); } catch (e) { /* never break the page */ }
    try { makeScrollableRegionsFocusable(); } catch (e) { /* never break the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  window.addEventListener('resize', function () { window.setTimeout(run, 200); });

  // Posters and carousel slides are inserted lazily while the shopper scrolls.
  var scheduled = null;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = window.setTimeout(function () { scheduled = null; run(); }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
}());
